import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HospitalItem = _resolveComponent("HospitalItem")
  const _component_PageFrame = _resolveComponent("PageFrame")

  return (_openBlock(), _createBlock(_component_PageFrame, null, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t('select a hospital')), 1)
    ]),
    subtitle: _withCtx(() => [
      _createVNode("span", null, _toDisplayString(_ctx.t('select a hospital to requesting')), 1)
    ]),
    content: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.hospitalList, (h) => {
        return (_openBlock(), _createBlock(_component_HospitalItem, {
          key: h.FacilityKey.valueOf(),
          hospitals: h,
          onClick: () => _ctx.SelectedHospital(h.FacilityKey.valueOf())
        }, null, 8, ["hospitals", "onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}